import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const MessageText = styled.div`
  padding: 0 15px;
  color: #111111;
  font-weight: 500;
  font-size: 1.1em;
  letter-spacing: 0.015em;
  position: absolute;
  left: 55px;

  ${mediaMaxWidth.tablet`
    font-size: 0.9em;
    position: relative;
    left: unset;
  `}
`;

export const CloseMessageButton = styled.span`
  font-size: 1.5em;
  transition: 0.1s ease-in-out;

  &:hover {
    color: #333;
  }

  &:focus {
    outline: none;
  }

  ${mediaMaxWidth.tablet`
    font-size: 1.3em;
  `}
`;
